/**
 * @generated SignedSource<<1e9aaa4e2f6dd83a723f9e3bd59603fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SignupRegenerateCodeMutationInput = {
  clientMutationId?: string | null;
  email: string;
  uid: string;
};
export type AuthSnsSignupResendMutation$variables = {
  input: SignupRegenerateCodeMutationInput;
};
export type AuthSnsSignupResendMutation$data = {
  readonly signupRegenerateCode: {
    readonly __typename: "SignupRegenerateCodeError";
    readonly message: string;
  } | {
    readonly __typename: "SignupRegenerateCodeToken";
    readonly token: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type AuthSnsSignupResendMutation = {
  response: AuthSnsSignupResendMutation$data;
  variables: AuthSnsSignupResendMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "signupRegenerateCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "token",
            "storageKey": null
          }
        ],
        "type": "SignupRegenerateCodeToken",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "SignupRegenerateCodeError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthSnsSignupResendMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthSnsSignupResendMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "414f2aa8be865ad965dd07b11be4ece7",
    "id": null,
    "metadata": {},
    "name": "AuthSnsSignupResendMutation",
    "operationKind": "mutation",
    "text": "mutation AuthSnsSignupResendMutation(\n  $input: SignupRegenerateCodeMutationInput!\n) {\n  signupRegenerateCode(input: $input) {\n    __typename\n    ... on SignupRegenerateCodeToken {\n      token\n    }\n    ... on SignupRegenerateCodeError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e01206bf90e4949da30dd115b6d9bc97";

export default node;
